import { render } from "./ArticleSmall.vue?vue&type=template&id=75fde28e&scoped=true"
import script from "./ArticleSmall.vue?vue&type=script&lang=js"
export * from "./ArticleSmall.vue?vue&type=script&lang=js"

import "./ArticleSmall.vue?vue&type=style&index=0&id=75fde28e&lang=scss&scoped=true"

import exportComponent from "/Users/Shared/PLAYLANE/Execution/P1901021/sandpiper/bbud-server/teacher-platform-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75fde28e"]])

export default __exports__